import { Injectable } from '@angular/core';
import { RestoreCartAdapter } from './restore-cart.adapter';
import { Observable } from 'rxjs';

@Injectable()
export class RestoreCartConnector {
  constructor(private cartAdapter: RestoreCartAdapter) {}

  restoreCart(cartGuid: string): Observable<string> {
    return this.cartAdapter.restoreCart(cartGuid);
  }
}
